var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logout"},[_c('a',{class:_vm.klass,attrs:{"href":"#"},on:{"click":_vm.logout}},[(_vm.icon)?_c('i',{class:(_vm.icon + " ti ti-lg")}):_vm._e(),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.text)}})])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b8225de","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/@triotech/vue-core/src/components/Logout.vue
// module id = 814
// module chunks = 1